import store from '../../redux/store';

class MasterPermissions {
  constructor() {
    this.permissionFramework = [];
  }

  getPermissionFramework() {
    const permissionFwk = localStorage.getItem('permissionFramework');
    const permissionsettings = JSON.parse(permissionFwk);

    if (permissionsettings === 'Super User') return permissionsettings;
    else {
      this.permissionFramework = JSON.parse(permissionFwk);
      console.log('getPermissionFramework: ', this.permissionFramework);
      return this.permissionFramework;
    }
  }

  setPermissionFramework(permissionFramework) {
    if (permissionFramework === 'Super User') {
      this.permissionFramework[0] = permissionFramework;
      localStorage.setItem(
        'permissionFramework',
        JSON.stringify(this.permissionFramework[0]),
      );
      console.log('setPermissionFramework: ', this.permissionFramework[0]);
    } else {
      this.permissionFramework = permissionFramework;
      localStorage.setItem(
        'permissionFramework',
        JSON.stringify(this.permissionFramework),
      );
      console.log('setPermissionFramework: ', this.permissionFramework);
    }
  }

  CheckPermission = (featureName) => {
    let permissionFwkLen = 0;
    let bPermissionSet = false;

    //let permissionsettings = JSON.parse(localStorage.getItem('permissionFramework'));
    const permissionsettings = store.getState().user.userRoleAndPermissions;
    const isSuperuser = store.getState().user?.userData?.SuperUser || false;

    if (permissionsettings === 'Super User' || isSuperuser) return true;

    this.permissionFramework = permissionsettings;

    permissionFwkLen = this.permissionFramework?.length;
    console.log('CheckPermission: ', this.permissionFramework);

    for (let idx = 0; idx < permissionFwkLen; idx++) {
      if (
        this.permissionFramework[idx].level === 'level-0' &&
        this.permissionFramework[idx].GroupName === featureName &&
        this.permissionFramework[idx].GroupEnabled === true
      ) {
        bPermissionSet = true;
      }
      if (
        this.permissionFramework[idx].level === 'level-1' &&
        this.permissionFramework[idx].PermissionLevel1 === featureName &&
        this.permissionFramework[idx].PermissionLevel1Enabled === true
      ) {
        bPermissionSet = true;
      }
      if (
        this.permissionFramework[idx].level === 'level-2' &&
        this.permissionFramework[idx].PermissionLevel2 === featureName &&
        this.permissionFramework[idx].PermissionLevel2Enabled === true
      ) {
        bPermissionSet = true;
      }
      if (
        this.permissionFramework[idx].level === 'level-3' &&
        this.permissionFramework[idx].PermissionLevel3 === featureName &&
        this.permissionFramework[idx].PermissionLevel3Enabled === true
      ) {
        bPermissionSet = true;
      }
      if (
        this.permissionFramework[idx].level === 'level-4' &&
        this.permissionFramework[idx].PermissionLevel4 === featureName &&
        this.permissionFramework[idx].PermissionLevel4Enabled === true
      ) {
        bPermissionSet = true;
      }
    }
    return bPermissionSet;
  };

  resetPermissionFramework() {
    this.permissionFramework = [];
  }
}

export default new MasterPermissions();
